import { render, staticRenderFns } from "./fileInfo.vue?vue&type=template&id=ad225d62&"
import script from "./fileInfo.vue?vue&type=script&lang=js&"
export * from "./fileInfo.vue?vue&type=script&lang=js&"
import style0 from "./fileInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports